import { ValuesRef } from '../types';
import { toCalendarDateFormat } from 'lib/utils';

export function canDraftBeApplied(values: ValuesRef) {
  const { draftDates, props } = values.current;
  return !!(
    draftDates.startDate &&
    draftDates.endDate &&
    (!areEqual(draftDates.startDate, props.startDate) || !areEqual(draftDates.endDate, props.endDate))
  );
}

function dateToKey(date?: Date) {
  return date ? toCalendarDateFormat(date) : '';
}

function areEqual(a?: Date, b?: Date) {
  return dateToKey(a) === dateToKey(b);
}
